import { createColumnDate, createColumnInput, createColumnSelect, createColumnTreeSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callRequestDepartment } from "../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { callFreeSaleObjective } from "../../free-sale/free-sale/free-sale.section";
import { callCountry } from "../../free-sale/request/free-sale-info/free-sale-info.section";
import { dateDiffStr } from "../../../../utils/date";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.freeSale"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({ title: () => i18n.global.t("views.report.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.freeSale.registrationCertificate"),
            dataIndex: "refHaz.approveCode",
            dataIndexValue: ({ record }) =>
                record.refObjective?.key === "1"
                    ? record.refHaz?.approveCode
                    : record.refInform?.approveCode,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh"),
            dataIndex: "refHaz.tradeNameTh",
            dataIndexValue: ({ record }) =>
                record.refObjective?.key === "1" ? record.refHaz?.tradeNameTh : record.refInformProduct?.refHaz?.tradeNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.freeSale.refObjective"),
            dataIndex: "refObjective.value",
            inputProp: () => ({ list: callFreeSaleObjective, optLabel: "value" }),
            search: { visible: () => true, name: "refObjective.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.freeSale.refCountry"),
            dataIndex: "refCountry.nameTh",
            inputProp: () => ({ list: callCountry, optLabel: "nameTh" }),
            search: { visible: () => true, name: "refCountry.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: () => callRequestDepartment({ refRequestDocKey: "22" }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { visible: () => false, name: "refDepartment.id" },
            width: 200
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docTimeLive"),
            // dataIndexValue: () => "1 ปี",
            dataIndexValue: ({ record }) => dateDiffStr({ record }), sorter: false,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
